/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import React from 'react';
import { getAlActions } from './alActions';

// The grid's single "AL Action" cell: one button per approval the AL team currently owes on this
// row (see alActions.js for what each one is and does). Same frameworkComponent pattern as
// epodgateactions.js / alReviewCellAction.js - reads state from props.context.componentParent and
// calls its existing handlers. Hovering a button shows what it does (native title tooltip).
const AlUnifiedActions = (props) => {
    const parent = props.context && props.context.componentParent;
    if (!parent) return null;

    const actions = getAlActions(props.data, parent);
    if (actions.length === 0) return null;

    const classFor = (variant) => 'btn btn-' + variant;
    return (
        <div>
            {actions.map((a) => (
                <button
                    key={a.key}
                    className={classFor(a.variant)}
                    style={{ padding: '2px 8px', fontSize: '12px', margin: '0 4px 0 0' }}
                    title={a.title}
                    disabled={a.disabled}
                    onClick={(e) => { e.stopPropagation(); a.onClick(); }}
                >
                    {a.label}
                </button>
            ))}
        </div>
    );
};

export default AlUnifiedActions;
